<template lang="pug">
footer(v-if="showFooter")
  .footer__container
    .footer__item
      h1.footer__item--title Products
      ul
        li
          a(href='/products/mac/cinemagraph-pro/') Cinemagraph Pro macOS
        li
          a(href='/products/ios/cinemagraph-pro/') Cinemagraph Pro iOS
        li
          a(href='/products/ios/blendeo/') Blendeo
        li
          a(href='/products/mac/persecond/') Persecond
        li
          a(href='https://itunes.apple.com/app/flixel-tv/id1043381618') Flixel TV
        li(@click='goToScreensaverUrl()') Flixel Screensaver
        li
          a(href='/products/hosting/') Cinemagraph Hosting
        li
          a(href="/products/pricing") Pricing
    .footer__item
      h1.footer__item--title Company
      ul
        li
          router-link(to='/company') About Flixel
        li
          a(href='/studios/') Flixel Studios
        li
          a(href='http://blog.flixel.com/contact/') Contact Flixel
        li
          a(href='http://blog.flixel.com/flixel-press') Press
        li
          a(href='/lp/affiliate/') Affiliates
    .footer__item
      h1.footer__item--title Blog
      ul
        li
          a(href='http://blog.flixel.com') All Categories
        li
          a(href='http://blog.flixel.com/category/photography/') Photography
        li
          a(href='http://blog.flixel.com/category/marketing/') Marketing
        li
          a(href='http://blog.flixel.com/category/flixel-tips-and-tricks/') Tutorials
    .footer__item
      h1.footer__item--title Social
      ul
        li
          a(href='https://www.facebook.com/flixelphotos/') Facebook
        li
          a(href='https://twitter.com/Flixel') Twitter
        li
          a(href='https://www.instagram.com/flixelphotos') Instagram
        li
          a(href='https://www.youtube.com/channel/UC0TePK05Rsm3GnPdNyLihWA') Youtube
        li
          a(href='https://www.snapchat.com/add/flixelphotos') Snapchat
    .footer__item
      h1.footer__item--title Learn
      ul
        li
          a(href='/tutorials/') Tutorials
        li
          a(href='/case-studies') Case Studies
        li
          a(href='http://support.flixel.com/') Help Center
        li
          a(href='https://forums.flixel.com') Forums
    .footer__item
      h1.footer__item--title Resources
      ul
        li
          router-link(to='/terms/') Terms &amp; Conditions
        li
          router-link(to='/sales-policy/') Sales Policy
        li
          router-link(to='/privacy/') Privacy Policy
</template>

<script>
import router from '../router';

export default {
  name: 'Footer',
  data() {
    return {
      showFooter: true,
    };
  },
  mounted() {
    if (router.currentRoute.name === 'Login'
        || router.currentRoute.name === 'Register'
        || router.currentRoute.name === 'ForgotPassword') {
      this.showFooter = false;
    } else {
      this.showFooter = true;
    }
  },
  watch: {
    '$route': function () {
      if (router.currentRoute.name === 'Login'
          || router.currentRoute.name === 'Register'
          || router.currentRoute.name === 'ForgotPassword') {
        this.showFooter = false;
      } else {
        this.showFooter = true;
      }
    },
  },
  methods: {
    goToScreensaverUrl() {
      const ENV = process.env;
      const location = ENV.url + '/products/mac/screensaver/download/';
      window.location.href = location;
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Footer.vue